import { FC, useEffect, useState } from "react";
import { useSoftnetStore } from "../../hooks/useSoftnetStore";
import { useNavigate } from "react-router-dom";
import { RoutesMap } from "../../types";
import { Grid } from "@mui/material";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ApiStatus } from "../../types/api/status";

const columns = [
    { type: 'text', field: 'id', label: 'N°', align: 'center', format: (row, index) => index + 1 },
    { type: 'text', field: 'nombre_rz', label: 'Nombre/Razón social', align: 'center' },
    { type: 'text', field: 'rut', label: 'RUT', align: 'center' },
    { type: 'checkbox', field: 'checkbox', label: 'checkbox', align: 'center' },
];

const breadcrumbs = [
    { id: 1, label: 'Importaciones' },
    { id: 2, label: 'Importar ERP', pathname: RoutesMap.IMPORT_ERP },
    { id: 3, label: 'Clientes', pathname: RoutesMap.IMPORT_CUSTOMER },
]

export const ImportCustomer: FC = () => {

    const navigate = useNavigate()
    const { status, customersERP, getCustomers, importSelectCustomer } = useSoftnetStore()

    const [selected, setSelected] = useState<any>([])

    useEffect(() => {
        getCustomers()
    }, [])

    const onGoBack = () => {
        navigate({ pathname: RoutesMap.IMPORT_ERP })
    }

    const onAddFn = async () => {
        const payload = {
            dataCustomer: selected
        }
        const response = await importSelectCustomer(payload)
        if (response === true) setSelected([])
    }

    const selectAll = (event) => {
        if (event.target.checked) {
            const newSelected = customersERP.map((n) => n)
            setSelected(newSelected)
        } else {
            setSelected([])

        }
    }

    const onCheckbox = (row) => {
        const selectedIndex = selected.findIndex(selectedRow => selectedRow.id === row.id)
        let newSelected = []

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, row)
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1))
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1))
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            )
        }
        setSelected(newSelected)
    }

    const isSelected = (row) => {
        return selected.some(item => item.id === row.id)
    }

    return (
        <Grid item xs={12}>
            <CustomTable
                breadcrumbs={breadcrumbs}
                title={'Importar clientes del ERP Softnet'}
                columns={columns}
                rows={customersERP || []}
                loading={status === ApiStatus.FETCHING}
                onRowClick={() => { }}
                // onGoBack={onGoBack}
                onAddFn={onAddFn}
                onAddFnName={'Importar'}
                selectAll={selectAll}
                onCheckbox={onCheckbox}
                isSelected={isSelected}
                hasOptions
                dense
            />
        </Grid>
    )
}